import { ReactNode } from 'react';
import { classNames } from '../../../utils';

function H1({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <h1
      className={classNames(
        'text-h1 font-bold text-gray-darkest',
        className && className,
      )}
    >
      {children}
    </h1>
  );
}

export default H1;
